import SuperMultiAutocomplete from 'components/forms/SuperMultiAutocomplete'
import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import MultiContactsAutocomplete from 'referencial/components/contact/components/MultiContactsAutocomplete'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import i18n from 'simple-react-i18n'
import useSandreList from 'utils/customHook/useSandreList'
import { authorizeContributors, authorizeFilter } from 'utils/HabilitationUtil'
import Input from '../../../../components/forms/Input'
import RadioButtons from '../../../../components/forms/RadioButtons'
import SimpleDatePicker from '../../../../components/forms/SimpleDatePicker'
import Textarea from '../../../../components/forms/Textarea'
import { getCampaignType } from '../../../../utils/CampaignUtil'
import { getDate } from '../../../../utils/DateUtil'
import { hasValue } from '../../../../utils/NumberUtil'
import { i18nize } from '../../../../utils/StringUtil'
import {
    QUALITY_CAMPAIGN_REQUEST,
    QUALITY_CAMPAIGN_TYPES,
} from '../../../constants/CampaignConstants'
import { Card, CardContent, Grid2 } from '@mui/material'


const FormQualityCampaign = ({
    campaign = {},
    onChangeCampaign = () => { },
    disabled = true,
}) => {
    const {
        contacts,
        contributors,
        accountUser,
    } = useSelector(store => ({
        contacts: store.ContactReducer.contacts,
        contributors: store.ContributorReducer.contributors,
        accountUser: store.AccountReducer.accountUser,
    }), shallowEqual)

    const {
        beginningApplication,
        endingApplication,
        requestType,
        name,
        campaignType,
        statut,
        contactCode,
        contributorCode,
        recipientCode,
        payerCode,
        samplerCode,
        marketRef,
        comment,
    } = campaign
    const startDate = beginningApplication && moment(beginningApplication, 'DD/MM/YYYY').valueOf()
    const endDate = endingApplication && moment(endingApplication, 'DD/MM/YYYY').valueOf()

    const campaignStatus = useSandreList('CAMPAGNES.STATUT')

    return (
        <Card sx={{ height: '100%' }}>
            <CardContent>
                <Grid2 container spacing={1}>
                    <Grid2 size={6}>
                        <Input
                            title={i18n.name}
                            value={name}
                            onChange={value => onChangeCampaign({ name: value })}
                            disabled={disabled}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <SimpleDatePicker
                            id='beginningApplication'
                            label={i18n.startDate}
                            value={startDate}
                            onChange={v => onChangeCampaign({ beginningApplication: getDate(v) !== '' ? getDate(v) : null })}
                            max={endDate}
                            disabled={disabled}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <SimpleDatePicker
                            id='endingApplication'
                            label={i18n.endDate}
                            value={endDate}
                            onChange={v => onChangeCampaign({ endingApplication: getDate(v) !== '' ? getDate(v) : null })}
                            min={startDate}
                            disabled={disabled}
                        />  
                    </Grid2>
                    <Grid2 size={6}>
                        <RadioButtons
                            elements={i18nize(QUALITY_CAMPAIGN_TYPES)}
                            disabled={disabled}
                            title={i18n.campaignType}
                            selected={getCampaignType(campaignType)}
                            onChange={e => onChangeCampaign({ campaignType: e })}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <SuperMultiAutocomplete
                            options={i18nize(QUALITY_CAMPAIGN_REQUEST)}
                            values={parseInt(requestType)}
                            label={i18n.requestType}
                            keyLabel='label'
                            keyValue='code'
                            onChange={value => onChangeCampaign({ requestType: value ? `${value}` : null })}
                            disabled={disabled}
                        />
                    </Grid2>
                    <Grid2 size={3}>
                        <SuperMultiAutocomplete
                            options={campaignStatus}
                            values={statut}
                            label={i18n.status}
                            keyValue='code'
                            onChange={value => onChangeCampaign({ statut: value })}
                            disabled={disabled}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <MultiContributorsAutocomplete
                            label={i18n.laboratory}
                            options={authorizeContributors(contributors, accountUser, parseInt(recipientCode))}
                            onChange={id => onChangeCampaign({ recipientCode: hasValue(id) && `${id}` || undefined })}
                            values={parseInt(recipientCode)}
                            displayWithCode
                            disabled={disabled}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <MultiContributorsAutocomplete
                            label={i18n.sampler}
                            options={authorizeContributors(contributors, accountUser, parseInt(samplerCode))}
                            onChange={id => onChangeCampaign({ samplerCode: hasValue(id) && `${id}` || undefined })}
                            values={parseInt(samplerCode)}
                            displayWithCode
                            disabled={disabled}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <MultiContributorsAutocomplete
                            label={i18n.producer}
                            options={authorizeContributors(contributors, accountUser, parseInt(contributorCode))}
                            onChange={id => onChangeCampaign({ contributorCode: hasValue(id) && `${id}` || undefined })}
                            values={parseInt(contributorCode)}
                            displayWithCode
                            disabled={disabled}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <MultiContactsAutocomplete
                            label={i18n.contact}
                            options={authorizeFilter(contacts, accountUser, contactCode, 'contributor')}
                            onChange={(id) => onChangeCampaign({ contactCode: id })}
                            values={contactCode}
                            displayWithCode
                            keyLabel='name'
                            disabled={disabled}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <MultiContributorsAutocomplete
                            label={i18n.payer}
                            options={authorizeContributors(contributors, accountUser, parseInt(payerCode))}
                            onChange={id => onChangeCampaign({ payerCode: hasValue(id) && `${id}` || undefined })}
                            values={parseInt(payerCode)}
                            displayWithCode
                            keyLabel='labelDisplay'
                            disabled={disabled}
                        />
                    </Grid2>
                    <Grid2 size={4}>
                        <Input
                            title={i18n.offerCall}
                            value={marketRef}
                            onChange={value => onChangeCampaign({ marketRef: value })}
                            disabled={disabled}
                        />
                    </Grid2>
                    <Grid2 size={12}>
                        <Textarea
                            title={i18n.comment}
                            value={comment}
                            onChange={value => onChangeCampaign({ comment: value })}
                            disabled={disabled}
                        />
                    </Grid2>
                </Grid2>
            </CardContent>
        </Card>
    )
}

FormQualityCampaign.propTypes = {
    campaign: PropTypes.shape({
        beginningApplication: PropTypes.string,
        endingApplication: PropTypes.string,
        name: PropTypes.string,
        campaignType: PropTypes.number,
        statut: PropTypes.number,
        contactCode: PropTypes.number,
        contributorCode: PropTypes.string,
        recipientCode: PropTypes.string,
        samplerCode: PropTypes.string,
        payerCode: PropTypes.string,
        marketRef: PropTypes.string,
        comment: PropTypes.string,
    }),
    disabled: PropTypes.bool,
    onChangeCampaign: PropTypes.func,
}

export default FormQualityCampaign